import botConfig from '../config/.bot-config.json';

export const BUCKEYE_BOT = botConfig?.name
export const INTENTS = {
    POSITIVE: botConfig?.intents?.positive || 'Thumbs up',
    NEGATIVE: botConfig?.intents?.negative || 'Thumbs down',
    HELP: botConfig?.intents?.help || 'Help',
    WELCOME: botConfig?.intents?.welcome || 'Welcome'
}
export const WELCOME_MESSAGE = process.env.REACT_APP_WELCOME_MESSAGE || 'Welcome to Buckeye Chat! Send me your questions.'